// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"12e30b0e","51":"2623f581","130":"0b525632","131":"60e7be63","193":"7e759008","332":"5e92e180","349":"d540214e","448":"5e305dae","452":"92a5399f","488":"9074bf50","559":"25f0f231","613":"e6b8bb7d","807":"53ff3062","892":"d706ad90","951":"19944c66","975":"a2823f8c"}[chunkId] + ".chunk.js";
};